<div class="precanned-reports-cont">
  <div class="side-navigation trends">
    <button #mobileBtnClose class="btn btn-link mobile-btn-close" (click)="closeMobileNav()">
      <i class="fa fa-close"></i>
    </button>
    <div class="input-group search-keywords">
      <div class="input-group-prepend">
        <img src="/assets/images/icon-search-keywords.svg" alt="Search Icon" />
      </div>
      <input type="text" class="form-control search-keywords" placeholder="Search for filters" aria-label="Username"
        (ngModelChange)="searchFilters($event)" [(ngModel)]="searchInputValue" aria-describedby="basic-addon1">
      <a class="btn btn-link clear-search" *ngIf="searchInputValue?.length > 0" (click)="clearSearchFilters()"><i
          class="fa fa-times"></i></a>
    </div>
    <div *ngIf="foundFilters" class="searched-filters">
      <h6 class="title">
        Searched Filters
      </h6>
      <div id="accordion-found-filters" role="tablist" aria-multiselectable="true" *ngIf="foundFilters?.length > 0">
        <div class="card" *ngFor="let item of foundFilters; let i = index;" [hidden]="item?.hidden">
          <div class="card-header" role="tab" [attr.id]="'heading-'+item.param">
            <h5 class="mb-0">
              <a data-toggle="collapse" data-parent="#accordion-found-filters" [attr.href]="'#collapse-'+item.param"
                aria-expanded="false" [attr.aria-controls]="'collapse-'+item.param" (click)="showOptions(item)">
                <div class="report-title">{{item.label}}</div>
              </a>
            </h5>
          </div>

          <div [attr.id]="'collapse-'+item.param" class="collapse" role="tabpanel"
            [attr.aria-labelledby]="'heading-'+item.param">
            <div class="card-block">
              <app-side-filter-item [item]="item" [tabbedGroup]="tabbedGroup" [currentConfig]="currentConfig"
                [selectedFilterValues]="selectedFilterValues" [cannedreports]="cannedreports"
                [loadingData]="loadingData" [noFacets]="noFacets" [facets]="facets"
                [currentCannedReportUpdater]="currentCannedReportUpdater"
                [importedFileNameUpdater]="importedFileNameUpdater" [facetsUpdater]="facetsUpdater"
                [showOptionsInvoker]="showOptionsInvoker" [routeFilterValuesUpdater]="routeFilterValuesUpdater"
                (closeMobileNav)="closeMobileNav($event)"
                [onDropdownFilterSelectInvoker]="onDropdownFilterSelectInvoker"></app-side-filter-item>
            </div>
          </div>
        </div>
      </div>
      <ul class="nav flex-column" *ngIf="foundFilters?.length <= 0">
        <li class="nav-item">
          <a class="nav-link">No filters found.</a>
        </li>
      </ul>
    </div>
    <div *ngIf="!foundFilters && importList && importList?.length > 0">
      <h6 class="title">
        Imported
      </h6>
      <ul class="nav flex-column imported-list">
        <li class="nav-item flex-column flex-wrap align-items-start justify-content-start"
          *ngFor="let importedFile of importList">
          <div class="canned-cont">
            <a class="btn canned-link importedFile"
              [ngClass]="{'active': importedFile.bulkUploadReportId === bulkUploadReportId}" [routerLink]=""
              (click)="importFileClick(importedFile.bulkUploadReportId)">
              <div class="d-flex justify-content-between align-items-center">
                <div class="d-flex align-items-center">
                  {{importedFile?.importedFileName}}
                  <a class="btn btn-link p-0" (click)="deleteImportedFile(bulkUploadReportId)" hidden>
                    <i class="fa fa-times-circle"></i>
                  </a>
                </div>
                <div class="expiration">{{(importedFile?.expiresOn - currentTimeMills) | duration:
                  'ms':'ddhhmmssShort'}} left</div>
              </div>
            </a>
          </div>
        </li>
      </ul>
    </div>

    <div class="precanned-reports pt-0">
      <h6 class="title">
        <a class="btn btn-link p-0 d-flex justify-content-between align-items-center width-100p"
          [ngClass]="{disabled: followingCount <= 0}" (click)="followingClick()">
          Following
          <span class="following-count text-lowercase">
            <span class="mr-1">{{followingCount}}</span>
            <ng-container *ngIf="currentConfig?.key === 'apps'">app</ng-container><ng-container
              *ngIf="currentConfig?.key === 'domains'">domain</ng-container><ng-container
              *ngIf="currentConfig?.key === 'ctv'">ctv app</ng-container><ng-container
              *ngIf="followingCount > 1 || followingCount === 0">s</ng-container>
          </span>
        </a>
      </h6>
    </div>

    <div *ngIf="!foundFilters" class="precanned-reports pt-0 save-presets">
      <h6 class="title" *ngIf="presetsList?.length > 0 || cannedreports?.length">
        Presets
      </h6>

      <ng-container *ngIf="presetsList?.length > 0">
        <ul class="nav flex-column">
          <li class="nav-item flex-column saved-presets align-items-start">
            <div class="canned-cont">
              <a class="nav-link d-flex justify-content-between font-weight-600" data-toggle="collapse"
                href="#myPresets" aria-expanded="false" aria-controls="myPresets">
                My Presets
                <i class="fa fa-plus"></i>
                <i class="fa fa-minus"></i>
              </a>
              <div class="collapse" id="myPresets">
                <ul class="list-group">
                  <li class="list-group-item" *ngFor="let preset of presetsList">
                    <a class="btn btn-link p-0" (click)="loadPreset(preset)">
                      {{preset?.title}}
                      <a class="btn btn-link p-0 ml-1 delete-preset" (click)="deletePreset($event, preset)"><i
                          class="fa fa-times-circle"></i></a>
                    </a>
                  </li>
                </ul>
              </div>
            </div>
          </li>
        </ul>
      </ng-container>
      <ng-container *ngIf="cannedreports && cannedreports?.length > 0">
        <ul class="nav presets-list" *ngFor="let canned of cannedreports; let i = index;">
          <li class="nav-item" *ngFor="let report of canned.reports">
            <a class="nav-link font-weight-600" [ngClass]="{'disabled': !report?.filters && !report?.mainFilters}"
              (click)="cannedClick(report)">
              <div class="report-title">{{report.title}}</div>
            </a>
          </li>
        </ul>
      </ng-container>
    </div>
    <div *ngIf="!foundFilters" class="toplevel-categories">
      <h6 class="title">
        Filters <a class="btn btn-link btn-clear-filters p-0" (click)="clearAllFilters()">Clear All</a>
      </h6>
      <ng-container *ngFor="let topLevelCategory of currentConfig?.topLevelCategories; let k = index;">
        <div *ngIf="!topLevelCategory.hidden" class="toplevel-category">
          <h6 class="title">
            {{topLevelCategory.label}}
          </h6>

          <ul class="nav flex-column">
            <li class="nav-item" *ngFor="let tabbedGroup of topLevelCategory?.groups; let i = index;">
              <ng-container *ngIf="!tabbedGroup?.hidden">
                <div class="canned-cont" [ngClass]="{'only-one-item' : tabbedGroup?.items?.length === 1}">
                  <a class="btn canned-link font-weight-600" *ngIf="tabbedGroup?.items?.length > 1"
                    [ngClass]="{collapsed: tabbedGroup.collapsed, selected: tabbedGroup.selected}"
                    data-toggle="collapse" href="#sidefilterCollapse2{{k}}{{i}}" role="button" aria-expanded="false"
                    aria-controls="sidefilterCollapse">
                    {{tabbedGroup.label}} <i class="fa fa-minus"></i> <i class="fa fa-plus"></i>
                  </a>
                  <div class="collapse level1" [attr.data-tabbedgroup-key]="tabbedGroup.key"
                    [ngClass]="{show: !tabbedGroup.collapsed || tabbedGroup?.items?.length === 1}"
                    id="sidefilterCollapse2{{k}}{{i}}">
                    <div class="card card-body" [ngClass]="{'border-0' : tabbedGroup?.items?.length === 1}">
                      <div class="accordion" [attr.id]="'accordion'+tabbedGroup.key" role="tablist"
                        aria-multiselectable="true">
                        <div class="card level2"
                          [ngClass]="{ selected: item.selected, 'border-0' : tabbedGroup?.items?.length === 1, 'pl-0' : tabbedGroup?.items?.length === 1 }"
                          *ngFor="let item of tabbedGroup?.items" [hidden]="item?.hidden">
                          <ng-container *ngIf="!item.hidden">
                            <div class="card-header"
                              [ngClass]="{'pl-0' : tabbedGroup?.items?.length === 1, 'py-4px' : tabbedGroup?.items?.length === 1}"
                              role="tab" [attr.id]="'heading'+tabbedGroup.key+item.param">
                              <h5 class="mb-0">
                                <a data-toggle="collapse"
                                  [ngClass]="{'font-weight-600' : tabbedGroup?.items?.length === 1}"
                                  [attr.data-parent]="'#accordion'+tabbedGroup.key"
                                  [attr.href]="'#collapse'+tabbedGroup.key+item.param" aria-expanded="false"
                                  [attr.aria-controls]="'collapse'+tabbedGroup.key+item.param"
                                  (click)="showOptions(item)">
                                  {{item.label}}
                                </a>
                                <img class="icon-filter-applied" src="/assets/images/icon-12-filter-applied.svg"
                                  alt="Filter Icon" />
                              </h5>
                            </div>
                            <div [attr.id]="'collapse'+tabbedGroup.key+item.param" class="collapse level2"
                              role="tabpanel" [attr.aria-labelledby]="'heading'+tabbedGroup.key+item.param">
                              <div class="card-block">
                                <app-side-filter-item [item]="item" [tabbedGroup]="tabbedGroup"
                                  [currentConfig]="currentConfig" [selectedFilterValues]="selectedFilterValues"
                                  [cannedreports]="cannedreports" [loadingData]="loadingData" [noFacets]="noFacets"
                                  [facets]="facets" [currentCannedReportUpdater]="currentCannedReportUpdater"
                                  [importedFileNameUpdater]="importedFileNameUpdater" [facetsUpdater]="facetsUpdater"
                                  [showOptionsInvoker]="showOptionsInvoker"
                                  [routeFilterValuesUpdater]="routeFilterValuesUpdater"
                                  [onDropdownFilterSelectInvoker]="onDropdownFilterSelectInvoker">
                                </app-side-filter-item>
                              </div>
                            </div>
                          </ng-container>

                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </ng-container>
            </li>
          </ul>
        </div>
      </ng-container>
    </div>
  </div>
</div>